<template>
  <ReportFieldRow
    :label="label"
    :extraCount="extraCount"
    @add="$emit('add', label)"
  >
    <template v-slot:badges>
      <DismissibleBadge
        v-for="parameter in displayParameters"
        :key="parameter.key"
        @click="$emit('click', parameter)"
        @dismiss="$emit('dismiss', parameter)"
      >
        {{ parameter.key }}
      </DismissibleBadge>
    </template>
  </ReportFieldRow>
</template>
<script>
import { DismissibleBadge } from '@mikmak/components';
import ReportFieldRow from './ReportFieldRow.vue';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    parameters: {
      type: Array,
    },
    displayLimit: {
      type: Number,
      default: 3,
      validator: val => val > 0 && val <= 4,
    },
  },
  components: {
    DismissibleBadge,
    ReportFieldRow,
  },
  computed: {
    displayParameters() {
      return this.parameters.slice(0, this.displayLimit);
    },
    extraCount() {
      return this.parameters.length - this.displayLimit;
    },
  },
};
</script>
